
mobileSize = 800;
// Countdown
function placeCountdown() {
	if ($('body').hasClass('saffireMobileSize')) {
		$('.countdown-wrapper').insertAfter('.home-banner');
	} else {
		$('.countdown-wrapper').appendTo('header');
	}
}
$(document).ready(function () {
	$('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
	placeCountdown();
	//prepend general message into header
	if ($("body").hasClass("generalMessageOn")) {
		$(".generalmessage").prependTo(".header");
	}
	var searchInput = $('.searchBox input');
	searchInput.val('Search');
	searchInput.on("click", function () {
		ClearDefaultText(this, 'Search');
	});
	searchInput.on("blur", function () {
		if ($.trim($(this).val()) == '') {
			$(this).val('Search');
		}
	});
	$(".arrow-down").click(function() {
		$('html,body').animate({
			scrollTop: $("#seoWidget").offset().top},
			'slow');
	});
});

$(window).load(function () {
	// Weather Bug
	setInterval(function () {
		var str = $('#weatherBugDescription').text();
		var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
		if (!weatherBugSet && str != '') {
			$('#weatherBugWidget').addClass('weatherBugSet');
			var findSpace = str.lastIndexOf(' ');
			var stringLength = str.length;
			var res = str.substring(findSpace, stringLength);
			var start = str.substring(0, findSpace);
			$('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
			$('#weatherBugWidget').css('visibility', 'visible');
		}
	}, 12);
	placeCountdown();
});
$(window).resize(function () {
	placeCountdown();
});